<template>
  <div class="w-full mt-4 overflow-hidden animate-pulse">
    <div
      class="hidden md:grid lg:grid-cols-12 md:grid-cols-8 gap-2 w-full items-center py-2 border-b bg-gray-50"
    >
      <div class="lg:col-span-2 md:col-span-2">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 md:col-span-1">
        <div class="h-4 w-12 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 md:col-span-1">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 md:col-span-1">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 md:col-span-1">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 md:col-span-1">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 hidden lg:block">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 hidden lg:block">
        <div class="h-4 w-24 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-1 md:col-span-1">
        <div class="h-4 w-12 bg-slate-200 rounded"></div>
      </div>
    </div>

    <div class="flex flex-col">
      <div
        v-for="n in 5"
        :key="n"
        class="grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-2 w-full items-center py-4 border-b border-gray-100"
      >
        <div class="lg:col-span-2 md:col-span-2 col-span-12">
          <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 md:col-span-1 col-span-6">
          <div class="h-4 w-16 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 md:col-span-1 col-span-6">
          <div class="h-4 w-8 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 md:col-span-1 col-span-6">
          <div class="h-4 w-24 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 md:col-span-1 col-span-12">
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-2 md:col-span-1 col-span-6 flex items-center gap-2">
          <div class="h-8 w-8 rounded-full bg-slate-200 shrink-0"></div>
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 col-span-12 hidden lg:block">
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-2 col-span-6 hidden lg:flex items-center gap-2">
          <div class="h-8 w-8 rounded-full bg-slate-200 shrink-0"></div>
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-1 md:col-span-1 col-span-12 flex gap-4">
          <div class="h-6 w-6 bg-slate-200 rounded"></div>
          <div class="h-6 w-6 bg-slate-200 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
